import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
 import { Link, useNavigate } from "react-router-dom";

const API_URL = "https://subk.education.com.ly/back/api/accounts";

function AccountPage() {
  const navigate = useNavigate(); // Use useNavigate hook for navigation

   ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'AccountPage';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({
    AccountName: "",
    AccountType: "Asset",
    ParentAccountID: "",
    UserID: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [showRegisterForm, setShowRegisterForm] = useState(false);

  const userdata = localStorage.getItem("USER_data");
  const userData = JSON.parse(userdata);
  const userid = userData.id;

  useEffect(() => {
    if (userid) {
      setForm((prevData) => ({
        ...prevData,
        UserID: userid,
      }));
    }
  }, [userid]);

  const fetchAccounts = async () => {
    try {
      const res = await axios.get(API_URL);
      setAccounts(res.data); // يجب أن يكون res.data يحتوي على total_balance لكل حساب
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API_URL}/${editingId}`, form);
      } else {
        await axios.post(API_URL, form);
      }
      setForm({
        AccountName: "",
        AccountType: "Asset",
        ParentAccountID: "",
        UserID: userid,
      });
      setEditingId(null);
      fetchAccounts();
      setShowRegisterForm(false);
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء حفظ الحساب");
    }
  };

  const handleEdit = (account) => {
    setShowRegisterForm(true);
    setForm({
      AccountName: account.AccountName,
      AccountType: account.AccountType,
      ParentAccountID: account.ParentAccountID || "",
      UserID: userid,
    });
    setEditingId(account.AccountID);
  };

  // const handleDelete = async (id) => {
  //   if (!window.confirm("هل أنت متأكد من حذف هذا الحساب؟")) return;
  //   try {
  //     await axios.delete(`${API_URL}/${id}`);
  //     fetchAccounts();
  //   } catch (err) {
  //     console.error(err);
  //     alert("حدث خطأ أثناء حذف الحساب");
  //   }
  // };

  // ================== TREE ==================
  function buildTree(list) {
    const map = {};
    const roots = [];

    list.forEach((item) => {
      map[item.AccountID] = { ...item, children: [] };
    });

    list.forEach((item) => {
      if (item.ParentAccountID) {
        if (map[item.ParentAccountID]) {
          map[item.ParentAccountID].children.push(map[item.AccountID]);
        } else {
          roots.push(map[item.AccountID]);
        }
      } else {
        roots.push(map[item.AccountID]);
      }
    });

    return roots;
  }

  const accountTree = buildTree(accounts);

  const levelColors = ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0"];
  const TreeNode = ({ node, level = 0 }) => {
    const [open, setOpen] = useState(true);
    const indent = 20;
    const color = levelColors[level] || levelColors[levelColors.length - 1];

    return (
      <li>
        <div
          style={{
            cursor: node.children.length > 0 ? "pointer" : "default",
            paddingRight: level * indent,
            margin: "2px 0",
            display: "inline-block",
          }}
          onClick={() => setOpen(!open)}
        >
          {node.children.length > 0 && (
            <span style={{ color: "#555", marginRight: 5 }}>
              {open ? "▼" : "▶"}
            </span>
          )}
          <span
            style={{
              backgroundColor: color + "33",
              color: color,
              padding: "2px 8px",
              borderRadius: 5,
              fontWeight: "bold",
              transition: "0.2s",
            }}
          >
            {node.AccountName} ({(node.total_balance).toFixed(4) || 0})
          </span>
        </div>
        {node.children.length > 0 && open && (
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {node.children.map((child) => (
              <TreeNode key={child.AccountID} node={child} level={level + 1} />
            ))}
          </ul>
        )}
      </li>
    );
  };
  // ==========================================

  return (
    <div className="container-fluid">
      <Row>
        <Col
          lg={4}
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
            borderRight: "1px solid #ccc",
            paddingRight: 10,
          }}
        >
          <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", paddingTop: "2px" }}>
            <h2>شجرة الحسابات</h2>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {accountTree.map((node) => (
                <TreeNode key={node.AccountID} node={node} />
              ))}
            </ul>
          </div>
        </Col>

        <Col lg={8}>
          <div className="card p-3">
            <div className="card-body p-0">
              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <div className="tbl-caption">
                  <h4 className="heading ms-3">إدارة الحسابات</h4>
                  {!showRegisterForm && (
                    <Link
                      to={"#"}
                      className="btn btn-primary btn-sm ms-1"
                      data-bs-toggle="offcanvas"
                      onClick={() => setShowRegisterForm(true)}
                    >
                      + إضافة حساب
                    </Link>
                  )}
                </div>
              </div>
            </div>
            {showRegisterForm && (
              <form className="row g-3 mb-4" onSubmit={handleSubmit}>
                <div className="col-md-3">
                  <input
                    type="text"
                    name="AccountName"
                    className="form-control"
                    placeholder="اسم الحساب"
                    value={form.AccountName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-3">
                  <select
                    name="AccountType"
                    className="default-select form-control"
                    value={form.AccountType}
                    onChange={handleChange}
                    required
                  >
                    <option value="Asset">أصل</option>
                    <option value="Liability">خصوم</option>
                    <option value="Equity">حقوق الملكية</option>
                    <option value="Revenue">إيراد</option>
                    <option value="Expense">مصروف</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    name="ParentAccountID"
                    className="default-select form-control"
                    value={form.ParentAccountID}
                    onChange={handleChange}
                  >
                    <option value="">-- اختر الحساب الأب --</option>
                    {accounts.map((acc) => (
                      <option key={acc.AccountID} value={acc.AccountID}>
                        {acc.AccountName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <button type="submit" className="btn btn-primary m-2">
                    {editingId ? "تحديث" : "إضافة"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => setShowRegisterForm(false)}
                  >
                    الغاء
                  </button>
                </div>
              </form>
            )}
            <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
              <table className="table table-bordered table-striped p-3">
                <thead className="table-dark">
                  <tr>
                    <th>الرقم</th>
                    <th>الاسم</th>
                    <th>النوع</th>
                    <th>الحساب الأب</th>
                    <th>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {accounts.map((acc) => {
                    const parent = accounts.find((p) => p.AccountID === acc.ParentAccountID);
                    return (
                      <tr key={acc.AccountID}>
                        <td>{acc.AccountID}</td>
                        <td>{acc.AccountName}</td>
                        <td>
                          {acc.AccountType === "Asset"
                            ? "أصل"
                            : acc.AccountType === "Liability"
                            ? "التزام"
                            : acc.AccountType === "Equity"
                            ? "حقوق الملكية"
                            : acc.AccountType === "Revenue"
                            ? "إيراد"
                            : "مصروف"}
                        </td>
                        <td>{parent ? parent.AccountName : "-"}</td>
                        <td>
                          <button className="btn btn-sm btn-primary m-2" onClick={() => handleEdit(acc)}>
                            تعديل
                          </button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => handleDelete(acc.AccountID)}>
                            حذف
                          </button> */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default AccountPage;
